import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormFeedback } from "reactstrap";

class SingleCheckbox extends React.Component {
  // Validate the checkbox field
  validate(value) {
    const { label, placeholder, required, error } = this.props;
    let errorMessage;
    const inputLabel = label || placeholder;
    const errorMessageLabel = error;
    if (!value && required) {
      errorMessage = errorMessageLabel
        ? `${errorMessageLabel}`
        : `${inputLabel} is required`;
    }
    return errorMessage;
  }
  checkboxstyle = { marginLeft: "2px", marginRight: "2px", fontWeight: "400" };

  // Render the input checkbox field
  renderInput({
    field: { value, onChange, onBlur },
    form: { touched, errors, values }
  }) {
    const {
      name,
      id,
      label,
      className,
      assignedPartnerValue,
      assignedPartnerChange
    } = this.props;

    const errorMessage = touched[name] && errors[name] ? errors[name] : null;
    const inputId = id || name;
    return (
      <div className={className} style={{ fontWeight: "400" }}>
        <div className="d-flex" key={name}>
          <input
            name={name}
            id={inputId}
            type="checkbox"
            value={value ? values : assignedPartnerValue}
            checked={assignedPartnerValue}
            onChange={e => {
              onChange(e);
              if (assignedPartnerChange) {
                assignedPartnerChange(e);
              }
            }}
            style={this.checkboxstyle}
          />
          <span htmlFor={id}>{label}</span>
        </div>
        {errorMessage && (
          <FormFeedback style={{ position: "absolute", marginTop: 20 }}>
            {errorMessage}
          </FormFeedback>
        )}
      </div>
    );
  }

  // Render the checkbox component
  render() {
    const { name, label } = this.props;
    return (
      <Field
        validate={this.validate.bind(this)}
        name={name}
        label={label}
        render={this.renderInput.bind(this)}
      />
    );
  }
}
SingleCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool
};
export default SingleCheckbox;
